import { render, staticRenderFns } from "./BioPyschoSocialShort.vue?vue&type=template&id=a3637d40"
import script from "./BioPyschoSocialShort.vue?vue&type=script&lang=js"
export * from "./BioPyschoSocialShort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports